var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-banner"},[_c('div',{staticClass:"page-banner__overlay"}),_c('div',{staticClass:"page-banner__content"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }